import React, { useEffect, useState } from 'react';

const TarjetaResultado: React.FC<{ registro: any, termino: string }> = ({ registro = {}, termino = '' }) => {

    const [terminosResaltados, setTerminosResaltados] = useState<any>([]);

    useEffect(() => {
        const terminos: any[] = [];
        Object.keys(registro).forEach((key) => {
            const valorPropiedad = '' + registro[key];
            let terminoDepurado;
            if (termino.includes(':')) {
                const terminoSplit = termino.split(':');
                terminoDepurado = terminoSplit[1].toLowerCase().trim();
            } else {
                terminoDepurado = termino.toLowerCase().trim();
            }
            if (valorPropiedad.toLowerCase().includes(terminoDepurado)) {
                const obj: any = {}
                obj[key] = registro[key];
                terminos.push(obj);
            }
        })
        setTerminosResaltados(terminos)
    }, [])

    return <>
        <div className='p-grid TarjetaResultadoContent'>
            <div className='p-col-3 LabelResultado'>
                ID:
            </div>
            <div className='p-col-9 IdResultado'>
                <a>{registro.idSql}</a>
            </div>
            {
                terminosResaltados ?
                    terminosResaltados.map((term: any) => (
                        Object.keys(term).map((key) => (
                            <div className='p-grid p-col-12'>
                                <div className='p-col-3 LabelResultado'>
                                    {key.toUpperCase()}
                                </div>
                                <div className='p-col-9'>
                                    {term[key]}
                                </div>
                            </div>
                        ))
                    ))
                    : null
            }
        </div>
    </>
}

export default TarjetaResultado